import * as React from 'react';
import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';
import _ from 'lodash';
import {
  ColumnProperties,
  EditColumnsDropdown as EditColumnsDropdownButton,
} from 'components/ContainerActions/EditColumnsDropdown';

interface Props {
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityChange: (newModel: Record<string, boolean>) => void;
}

const generateColumnStates = (columnVisibilityModel: GridColumnVisibilityModel) => {
  const columnStates: ColumnProperties[] = [
    {
      label: 'Holds to clear',
      visible: columnVisibilityModel.holds,
      key: 'holds',
    },
    {
      label: 'Last free day',
      visible: columnVisibilityModel.lastFreeDay,
      key: 'lastFreeDay',
    },
    {
      label: 'Pickup to schedule',
      visible: columnVisibilityModel.pickup,
      key: 'pickup',
    },
    {
      label: 'Empty to return',
      visible: columnVisibilityModel.emptyReturn,
      key: 'emptyReturn',
    },
    {
      label: 'Detention period',
      visible: columnVisibilityModel.detention,
      key: 'detention',
    },
    {
      label: 'Terminal open for dual returns',
      visible: columnVisibilityModel.dualReturns,
      key: 'dualReturns',
    },
    {
      label: 'Customer ID',
      visible: columnVisibilityModel.customerTag,
      key: 'customerTag',
    },
  ];
  return columnStates;
};

export const EditColumnsDropdown: React.FC<Props> = ({
  columnVisibilityModel,
  onColumnVisibilityChange,
}) => {
  const [columnStates, setColumnStates] = React.useState<ColumnProperties[]>(
    generateColumnStates(columnVisibilityModel)
  );

  const handleSetColumnsStates = (newColumnStates: ColumnProperties[]) => {
    onColumnVisibilityChange(_.mapValues(_.keyBy(newColumnStates, 'key'), 'visible'));
    setColumnStates(newColumnStates);
  };

  return (
    <EditColumnsDropdownButton
      columnStates={columnStates}
      setColumnStates={handleSetColumnsStates}
      usage="trackAndTrace"
    />
  );
};
EditColumnsDropdown.displayName = 'TrackAndTrace.Controls.actions.EditColumnsDropdown';
